export const MAIN_DISPATCHER_ID: string = 'mainDispatcher';

export const ASYNC_DOWNLOAD_DISPATCHER_PREFIX: string = 'AsyncDownloadDispatcher';
export const ASYNC_DOWNLOAD_DISPATCHER_PARTIAL_MATCH_SPLITTER: string = '_';
export const ASYNC_UPLOAD_DISPATCHER_NAME: string = 'AsyncUploadDispatcher';
export const DOWNLOAD_INDICATOR_WIDGET: string = 'DownloadIndicatorWidget';

export const INITIAL_UPLOAD_REQUEST_MAPPING_NAME_SUFFIX: string = '_INITIAL';
export const UPLOAD_REQUEST_DEFAULT_MAPPING_NAME: string = 'uploadStatus';
export const UPLOAD_REQUEST_CANCELED: number = -1;
export const UPLOAD_REQUEST_CANCEL_SCHEDULED: number = -2;
export const DISPATCHER_UPLOAD_CANCELED: string = 'DISPATCHER_UPLOAD_CANCELED';
export const DISPATCHER_ALL_UPLOAD_CANCELED: string = 'DISPATCHER_ALL_UPLOAD_CANCELED';

export const COOKIE: {
  THEME: string,
  LANGUAGE_LOCALE: string
} = {
  THEME: 'tp-theme',
  LANGUAGE_LOCALE: 'locale'
};
